<template>
  <div>
    <SimpleSmartHints v-if="isSimpleHint" :id="selectedReasonObject?.id" />
    <ListSmartHints v-if="isListHint" :id="selectedReasonObject?.id" />
    <UpsellSmartHints
      v-if="isUpsellHint"
      :id="selectedReasonObject?.id"
      @toggleChangeCampaignModal="toggleChangeCampaignModal"
    />
  </div>
</template>
<script setup>
import SimpleSmartHints from '@/components/rateConnect/pauseFlow/smartHints/SimpleSmartHints.vue'
import ListSmartHints from '@/components/rateConnect/pauseFlow/smartHints/ListSmartHints.vue'
import UpsellSmartHints from '@/components/rateConnect/pauseFlow/smartHints/UpsellSmartHints.vue'
import { computed } from 'vue'

const props = defineProps({
  isItemNetCPAEligible: Boolean,
  selectedReasonObject: [Object, null],
})

const listIds = [3, 5, 9, 10]
const simpleIds = [0, 2]
const upsellIds = [1, 4, 6, 7, 8]

const isEligibleForChange = computed(() => props.isItemNetCPAEligible)

const emit = defineEmits(['toggleChangeCampaignModal'])
const toggleChangeCampaignModal = () => emit('toggleChangeCampaignModal')
const isSimpleHint = computed(() => simpleIds.includes(props.selectedReasonObject?.id))
const isListHint = computed(
  () =>
    (upsellIds.includes(props.selectedReasonObject?.id) && !isEligibleForChange.value) ||
    listIds.includes(props.selectedReasonObject?.id)
)
const isUpsellHint = computed(() => upsellIds.includes(props.selectedReasonObject?.id) && isEligibleForChange.value)
</script>
<style scoped>
.required-info :deep(span) {
  color: var(--tw-color-red-700);
}
p :deep(span) {
  color: var(--tw-color-red-600);
}
</style>
